// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Ajny","box":"WorkspacesBox_box__ZDPKP","node":"WorkspacesBox_node__2drJ4"};